import { AfterViewInit, Component, ElementRef, EventEmitter, forwardRef, Inject, Input, OnChanges, Output, PLATFORM_ID, Renderer2, ViewChild } from '@angular/core';
import { ControlValueAccessor, UntypedFormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'gs-area-wysiwyg',
  templateUrl: './gs-area-wysiwyg.component.html',
  styleUrls: ['./gs-area-wysiwyg.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GsAreaWysiwygComponent),
      multi: true
    }
  ]
})
export class GsAreaWysiwygComponent implements ControlValueAccessor, AfterViewInit, OnChanges {
  // Inputs
  @Input() label: string;
  @Input() labelSmall: string;
  @Input() isEditable: boolean = false;
  @Input() name: string;
  @Input() placeholder: string;
  @Input() formControl: UntypedFormControl;
  @Input() cssClass: string;
  @Input() hideErrorMessage: boolean = false;
  @Input() rows: number;
  @Input() autoFocus: boolean = false;

  @ViewChild('quillEditor') quillEditor: any;

  isBrowser:boolean;
  // Outputs
  @Output() blur: EventEmitter<string> = new EventEmitter<string>();

  // Private variables
  private inputValue: string;
  public fnOnChange: any = () => { };
  public fnOnTouch: any = () => { };

  quillModule: any;
  show:boolean =false;
  quilldata: any;
  quill: any;

  constructor(private el: ElementRef, private renderer: Renderer2, @Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  async ngOnInit(): Promise<void> {
    if (isPlatformBrowser(this.platformId)) {
      const QuillModule = await import('quill');
      const ImageResizeModule = await import('quill-image-resize-module');
    
      const Quill = QuillModule.default;
      this.quilldata = Quill;
      const ImageResize = ImageResizeModule.default;
    
      // Register Font whitelist
      let Font = Quill.import('formats/font');
      Font.whitelist = ['arial', 'Roboto', 'cursive', 'fantasy', 'monospace', 'sans-serif', 'serif', 'times-new-roman'];
      Quill.register(Font, true);
    
      // Register Image Resize module
      Quill.register('modules/imageResize', ImageResize);
    
      this.quillModule = {
        imageResize: { displaySize: true },
        toolbar: {
          container: [
            ['bold', 'italic', 'underline', { 'color': [] }, { 'background': [] }, { 'align': [] },
            'blockquote', 'link', 'image', 'video', 
            { 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' },
            { 'font': ['arial', 'Roboto', 'cursive', 'fantasy', 'monospace', 'sans-serif', 'serif', 'times-new-roman'] },
            { 'size': ['small', false, 'medium', 'large', 'extralarge', 'huge'] },
            { 'header': [1, 2, 3, false] },
            'clean']
          ],
          // handlers: {
          //   video: () => {
          //     const url = prompt('Enter video URL');
          //     if (url && this.quill) {
          //       const range = this.quill.getSelection(true);
          //       this.quill.insertEmbed(range.index, 'video', url, 'user');
          //     }
          //   }
          // }
        }
      };
    }
    
    setTimeout(()=>{
      this.show = true;
    })
  }

  onEditorCreated(quill: any) {
    const tooltip = quill.theme?.tooltip;
    if (!tooltip) return;
  
    // Keep tooltip open when clicking inside URL box
    ['mousedown', 'click'].forEach(eventName => {
      tooltip.root.addEventListener(eventName, (event: any) => {
        event.stopPropagation();
      });
    });
  
    // Prevent blur from closing tooltip
    if (tooltip.textbox) {
      ['blur', 'focusout'].forEach(eventName => {
        tooltip.textbox.addEventListener(eventName, (event: any) => {
          event.preventDefault();
          event.stopPropagation();
        });
      });
    }
  }
  

  ngAfterViewInit(): void {
    if (this.autoFocus && this.isBrowser) {
      // Wait for the Quill editor to be fully initialized
      setTimeout(() => {
        if (this.quillEditor && this.quillEditor.quillEditor) {

          // editor.format('header', 1);     // Default: H1

        }
      }, 500);
    }
  }

  // applyDefaultFormat(data){
  //   this.quilldata.format('header', 1);
  // }
  // Method to focus the Quill editor when container is clicked
  public focusEditor(): void {
    // if (this.isBrowser && this.quillEditor && this.quillEditor.quillEditor) {
    //   this.quillEditor.quillEditor.focus();

    // }
  }

  ngOnChanges(): void {}

  private triggerChange($event): void {
    this.fnOnChange($event);
    const event = new CustomEvent('change', { bubbles: true });
    this.el.nativeElement.dispatchEvent(event);
  }

  public set value(val: string) {
    if (val !== undefined) {
      this.inputValue = val;
    }
  }

  public get value() {
    return this.inputValue;
  }

  public writeValue(val: string): void {
    this.value = val;
  }

  public writePlaceholder(val: string): void {
    this.placeholder = val;
  }

  public registerOnChange(fn: any): void {
    this.fnOnChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.fnOnTouch = fn;
  }

  public onChange(): void {
    this.triggerChange(this.inputValue);
  }
}
